export enum SignalRTargets {
    TenantUpdate = "TenantUpdate",
    VesselDlqBlobTargetName = "VesselDlqBlob",
    VesselDlqParserTargetName = "VesselDlqParser",
    VesselDlqPersistTargetName = "VesselDlqPersist",
    VesselQueueResponseTargetName = "VesselQueueResponse",
    VesselProcessingStatusTargetName = "VesselProcessingStatus"
}

export {};